import { fetchHTML } from './utils-fetch-html.js';

class CollectionGrid extends HTMLElement {
  abortController;

  connectedCallback() {
    this.unsubscribeSortChanged = subscribe('sort:changed', () => this.handleSortChange());
    this.unsubscribeFiltersUpdated = subscribe('filters:updated', () => this.handleSortChange());
  }

  disconnectedCallback() {
    this.unsubscribeSortChanged();
    this.unsubscribeFiltersUpdated();
  }

  /**
   * Handle sort change
   */
  async handleSortChange() {
    this.abortController?.abort();
    this.abortController = new AbortController();
    const searchParams = new URLSearchParams(window.location.search);

    try {
      const html = await fetchHTML(
        `${window.location.pathname}?section_id=main-collection&${searchParams}`
      );
      const parsedHTML = html.querySelector('collection-grid');
      const currentOpenDropdownIds = this.getOpenDropdownIds();

      this.restoreDropdownStates(currentOpenDropdownIds, parsedHTML);
      this.replaceWith(parsedHTML);
    } catch (error) {
      console.error(error);
    }
  }

  /**
   * Get IDs of currently open dropdowns
   * @returns {string[]} Array of IDs for open dropdowns
   */
  getOpenDropdownIds() {
    return Array.from(
      this.querySelectorAll('filter-list-dropdown [aria-controls][aria-expanded="true"]')
    ).map((dropdown) => dropdown.getAttribute('id'));
  }

  /**
   * Restore dropdown states in markup thats used to replace current markup
   * @param {string[]} currentOpenDropdownIds - Array of IDs for open dropdowns
   * @param {HTMLElement} html - Parsed markup
   * @returns {string[]} Array of IDs for open dropdowns
   */
  restoreDropdownStates(currentOpenDropdownIds, html) {
    currentOpenDropdownIds.forEach((id) => {
      const dropdown = html.querySelector(`#${id}`);
      if (dropdown) {
        dropdown.setAttribute('aria-expanded', 'true');
      }
    });
  }

  /**
   * Render product grid
   * @param {HTMLElement} html - HTML to render
   */
  renderProductGrid(html) {
    const parsedCollectionGrid = html.querySelector('collection-grid');
    this.innerHTML = parsedCollectionGrid.innerHTML;
  }
}

customElements.define('collection-grid', CollectionGrid);
